module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=TT - Trinidad and Tobago.5d3dfcbe.svg";